import React, { } from 'react';
import { connect } from 'react-redux';
import { TOGGLE_SEARCH } from '../../state/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import style from './style.module.scss';

const SearchIcon = ({ isSearchActive }) => {
    return !isSearchActive ?
        <>
            SEARCH
            <FontAwesomeIcon className={style.searchIcon} icon={"search"} />
        </> :
        <>

            <FontAwesomeIcon className={style.searchIcon} style={{ marginLeft: 0 }} icon={"times"} />
        </>
}

const SearchButton = props => {
    const { dispatch, isSearchActive } = props;
    const onClick = () => dispatch({ type: TOGGLE_SEARCH, bool: !isSearchActive })

    return (
        <span onClick={onClick} className={style.searchText}>
            <SearchIcon {...props} />
        </span>
    );
};

SearchButton.propTypes = {

};

export default connect(state => ({ isSearchActive: state.isSearchActive }))(SearchButton);